<template>
  <div id="chat-app">
    <chat-icon v-show="!show"/>
    <transition name="fade">
      <container-chat v-show="show"/>
    </transition>
  </div>
</template>

<script>
import ContainerChat from './components/ContainerChat'
import ChatIcon from './components/ChatIcon'
import fms from './boot/fms'

export default {
  fms,
  name: 'App',
  components: {
    ChatIcon,
    ContainerChat
  },
  computed: {
    show: function () {
      return this.$store.state.isOpenChat
    }
  }
}
</script>

<style lang="scss">
#chat-app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
  input:focus{
    outline: none;
  }
  textarea
  {
    font-family: inherit;
    font-size: 14px;
    resize: none;
    margin: 0;
  }
  textarea:focus{
    outline: none;
  }
  * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
